(function() {
    function initYmalCarousel(wrapperId) {
        var wrapper = document.getElementById(wrapperId);
        if (!wrapper) return;

        var track = wrapper.querySelector('.ymal-carousel__track');
        var items = track.querySelectorAll('.ymal-carousel__item');
        if (items.length <= 2) return;

        var carousel = wrapper.closest('.ymal-carousel');
        var prevBtn = carousel.querySelector('[data-carousel-prev]');
        var nextBtn = carousel.querySelector('[data-carousel-next]');
        var currentIndex = 0;
        var itemsPerPage = 2;

        function getItemWidth() {
            return items[0].offsetWidth + 12;
        }

        function updateButtons() {
            prevBtn.disabled = currentIndex === 0;
            nextBtn.disabled = currentIndex >= items.length - itemsPerPage;
        }

        function scrollTo(index) {
            currentIndex = Math.max(0, Math.min(index, items.length - itemsPerPage));
            track.style.transform = 'translateX(-' + (currentIndex * getItemWidth()) + 'px)';
            updateButtons();
        }

        prevBtn.addEventListener('click', function() { scrollTo(currentIndex - 1); });
        nextBtn.addEventListener('click', function() { scrollTo(currentIndex + 1); });

        updateButtons();
    }

    document.querySelectorAll('[data-carousel-next]').forEach(function(btn) {
        var wrapperId = btn.getAttribute('data-carousel-next');
        initYmalCarousel(wrapperId);
    });

    document.querySelectorAll('.ymal-carousel__track').forEach(function(track) {
        if (track.querySelector('.ymal-carousel__shade-picker')) {
            track.querySelectorAll('.ymal-carousel__shade-picker-wrapper').forEach(function(wrapper) {
                wrapper.classList.add('ymal-carousel__shade-picker-wrapper--has-picker');
            });
        }
    });

    // Shade picker listbox. Roles and keyboard support are added here only, so
    // other pages sharing the variant-selector snippet are unaffected.
    document.querySelectorAll('.ymal-carousel__shade-picker').forEach(function(picker) {
        var trigger = picker.querySelector('.ymal-carousel__shade-trigger');
        var swatchesPanel = picker.querySelector('.ymal-carousel__swatches');
        var swatchDot = picker.querySelector('.ymal-carousel__shade-swatch');
        var shadeName = picker.querySelector('.ymal-carousel__shade-name');
        var carouselWrapper = picker.closest('.ymal-carousel__wrapper');
        var listbox = picker.querySelector('[data-colors]');
        var options = Array.prototype.slice.call(picker.querySelectorAll('[data-colors-item]'));
        var productTitle = trigger.getAttribute('data-product-title') || '';

        if (listbox) {
            listbox.id = trigger.getAttribute('data-shades-id');
            listbox.setAttribute('role', 'listbox');
            listbox.setAttribute('aria-label', 'Shades for ' + productTitle);
        }
        options.forEach(function(option) {
            option.setAttribute('role', 'option');
        });

        function selectedOption() {
            return picker.querySelector('.colors__item.current');
        }

        // aria-selected follows .current; the selected shade is the only tab stop.
        function syncOptions(chosen) {
            var selected = chosen || selectedOption();
            var tabStop = selected || options[0];
            options.forEach(function(option) {
                option.setAttribute('aria-selected', option === selected ? 'true' : 'false');
                option.setAttribute('tabindex', option === tabStop ? '0' : '-1');
            });
            var name = selected ? selected.getAttribute('data-color') : '';
            trigger.setAttribute('aria-label', name
                ? 'Shade: ' + name + ', ' + productTitle
                : 'Choose shade for ' + productTitle);
        }

        var currentLabel = selectedOption();
        if (currentLabel) {
            var box = currentLabel.querySelector('.colors__item-box');
            if (box) swatchDot.style.backgroundColor = box.style.backgroundColor;
            shadeName.textContent = currentLabel.getAttribute('data-color') || 'Choose Shade';
        }
        syncOptions();

        function isOpen() {
            return swatchesPanel.classList.contains('is-open');
        }

        function openPanel() {
            if (carouselWrapper) {
                carouselWrapper.querySelectorAll('.ymal-carousel__swatches.is-open').forEach(function(el) {
                    el.classList.remove('is-open');
                });
                carouselWrapper.querySelectorAll('.ymal-carousel__shade-trigger[aria-expanded="true"]').forEach(function(el) {
                    el.setAttribute('aria-expanded', 'false');
                });
            }

            var item = picker.closest('.ymal-carousel__item');
            var available = trigger.getBoundingClientRect().top - item.getBoundingClientRect().top;
            swatchesPanel.style.maxHeight = Math.max(80, Math.floor(available)) + 'px';

            swatchesPanel.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');

            var focusTarget = selectedOption() || options[0];
            if (focusTarget) focusTarget.focus();
        }

        function closePanel(returnFocus) {
            swatchesPanel.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            if (carouselWrapper && !carouselWrapper.querySelector('.ymal-carousel__swatches.is-open')) {
                carouselWrapper.style.overflow = '';
            }
            if (returnFocus) trigger.focus();
        }

        trigger.addEventListener('click', function(e) {
            e.stopPropagation();
            if (isOpen()) {
                closePanel(false);
            } else {
                openPanel();
            }
        });

        trigger.addEventListener('keydown', function(e) {
            if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !isOpen()) {
                e.preventDefault();
                openPanel();
            } else if (e.key === 'Escape' && isOpen()) {
                closePanel(true);
            }
        });

        options.forEach(function(label) {
            label.addEventListener('click', function() {
                var box = this.querySelector('.colors__item-box');
                if (box) swatchDot.style.backgroundColor = box.style.backgroundColor;
                shadeName.textContent = this.getAttribute('data-color') || 'Choose Shade';
                // Sync with the clicked shade (global.js sets .current later), then
                // move focus, so the trigger already has the new name.
                syncOptions(this);
                closePanel(true);
            });
        });

        if (listbox) {
            listbox.addEventListener('keydown', function(e) {
                var option = e.target.closest('[data-colors-item]');
                if (!option) return;
                var index = options.indexOf(option);
                var next = null;

                if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    // Stop <variant-selects> from clicking it a second time.
                    e.stopPropagation();
                    option.click();
                    return;
                }
                if (e.key === 'Escape') {
                    e.preventDefault();
                    closePanel(true);
                    return;
                }
                if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                    next = options[index + 1] || options[0];
                } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                    next = options[index - 1] || options[options.length - 1];
                } else if (e.key === 'Home') {
                    next = options[0];
                } else if (e.key === 'End') {
                    next = options[options.length - 1];
                }

                if (next) {
                    e.preventDefault();
                    options.forEach(function(o) {
                        o.setAttribute('tabindex', o === next ? '0' : '-1');
                    });
                    next.focus();
                }
            });
        }

        // Tabbing out of the picker closes the panel.
        picker.addEventListener('focusout', function(e) {
            if (isOpen() && !picker.contains(e.relatedTarget)) {
                closePanel(false);
                syncOptions();
            }
        });
    });

    document.addEventListener('click', function() {
        document.querySelectorAll('.ymal-carousel__swatches.is-open').forEach(function(el) {
            el.classList.remove('is-open');
        });
        document.querySelectorAll('.ymal-carousel__shade-trigger[aria-expanded="true"]').forEach(function(el) {
            el.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.ymal-carousel__wrapper').forEach(function(w) {
            w.style.overflow = '';
        });
    });
})();